module.exports = __webpack_public_path__ + "img/icb-empty-e@2x.6275d13e.png";